<template>
  <div
    class="menu-page-desktop"
    :class="{ 'menu-page-mobile': $route.meta.mobile }"
  >
    <h1>{{ $t("canals5d-currents.title") }}</h1>
    <p>
      {{ $t("canals5d-currents.p1") }}
    </p>

    <p>
      {{ $t("canals5d-currents.p2") }}
    </p>

    <h2 class="center">
      <a href="https://vimeo.com/443989234" target="_blank">{{
        $t("canals5d-currents.watch_link")
      }}</a>
    </h2>

    <div
      class="page-image-container"
      :class="{ 'page-image-container-mobile': $route.meta.mobile }"
    >
      <img
        class="page-image"
        src="../images/canals5d-currents@2x.jpg"
        width="100%"
      />
      <p class="image-source">
        {{ $t("canals5d-currents.source") }}
      </p>
    </div>

    <hr />
    <page-footer />
  </div>
</template>

<script>
import PageFooter from "@/components/menus/pages/PageFooter.vue";

export default {
  components: {
    PageFooter
  },
  head: {
    meta: [
      {
        name: "viewport",
        content: "width=device-width, shrink-to-fit=YES",
        initialScale: "1.0",
        maximumScale: "1.0",
        minimumScale: "1.0",
        userScalable: "no"
      }
    ]
  }
};
</script>

<style scoped src="../css/main.css"></style>
<style scoped src="../css/canals5d.css"></style>
